/**
 * A simple wrapper to throw a TypeError when the value is null or undefined
 */
export function assertDefined<T>(value: T | undefined | null): T {
  if (value === undefined || value === null) throw new TypeError('Assertion Failed: value is not defined or is null.');
  return value;
}
